import useAxios from "../../hooks/useAxios";

const useSpectateTrlService = () => {
  const axiosGetAllTrl = useAxios();

  const getTrlFromAppId = async (posId) => {
    await axiosGetAllTrl.fetchData({
      url: `/approver/trl/${posId}`,
      method: "GET",
      // Admin oversight view — unlike the approver's own queue, this should
      // still show cancelled submissions.
      params: { includeCancelled: true },
    });
  };

  return {
    // list
    getTrlFromAppId,
    trlLoading: axiosGetAllTrl.loading,
    trlResponse: axiosGetAllTrl.response,
  };
};

export default useSpectateTrlService;
